import { createSelector } from 'reselect';

export const projectsSelector = (state) => state.get('projects');

// TODO: Deprecated: use validatedActiveProjectIdSelector instead
// We have two selectors for getting the active project id. This one is the "legacy"
// one, which only returns the raw value extracted from the URL without any
// transformation. It is used almost everywhere in the app, and in most cases, we
// do expect a Number, so we have to parse it.
//
// ValidatedActiveProjectIdSelector is the new one, which checks if the parsed value
// matches any of the project ids in the list of projects. It is assumed that if the
// value does not coincide, the user is trying to access a non-existent project.
//
// ValidatedActiveProjectIdSelector should be used everywhere, and the legacy one
// should be removed.
export const rawActiveProjectIdSelector = createSelector(
  projectsSelector,
  (projects) => projects.get('activeProjectId')
);

export const projectsListSelector = createSelector(
  projectsSelector,
  (projects) => projects.get('allProjects')
);

export const projectIdsSelector = createSelector(
  projectsListSelector,
  (projects) => projects.toJS().map(({ id }) => id)
);

// We have two selectors for getting the active project id. rawActiveProjectIdSelector is
// the "legacy" one, which only returns the raw value extracted from the URL without any
// transformation. It is used almost everywhere in the app, and in most cases, we
// do expect a Number, so we have to parse it.
//
// This is the new one, which checks if the parsed value
// matches any of the project ids in the list of projects. It is assumed that if the
// value does not coincide, the user is trying to access a non-existent project.
//
// ValidatedActiveProjectIdSelector should be used everywhere, and the legacy one
// should be removed.
export const validatedActiveProjectIdSelector = createSelector(
  rawActiveProjectIdSelector,
  projectIdsSelector,
  (rawProjectId, allProjectIds) => {
    if (!rawProjectId) {
      return null;
    }
    const parsedProjectId = Number(rawProjectId);
    return allProjectIds.includes(parsedProjectId) ? rawProjectId : null;
  }
);

export const projectsColorSelector = createSelector(
  projectsSelector,
  (projects) => projects.get('colors')
);

export const projectsListIdsSelector = createSelector(
  projectsSelector,
  (projects) => projects.get('allIds')
);

export const projectsByIdSelector = createSelector(
  projectsSelector,
  (projects) => projects.get('byId')
);

export const activeProjectSelector = createSelector(
  rawActiveProjectIdSelector,
  projectsByIdSelector,
  (projectId, projects) => projects.toJS()[projectId]
);

export const userRolesSelector = createSelector(
  rawActiveProjectIdSelector,
  projectsListSelector,
  (projectId, projects) => projects.toJS().find(({ id }) => id === +projectId)
);
export const adminRoleSelector = createSelector(
  userRolesSelector,
  (userRoles) => userRoles?.roles.includes('admin')
);

export const firstProjectIdSelector = createSelector(
  projectIdsSelector,
  (projectIds) => (projectIds.length > 0 ? projectIds[0] : null)
);
